define(['toolkit/b-toolkit/b-toolkit', 'toolkit/b-controls-group/b-controls-group'], function(toolkit){
	return toolkit['b-controls-group'].extend('b-social-icons', {
		template: 'app',

		render: function(item) {
			toolkit['b-toolkit'].fn.render.call(this);
		}
	});
});
